import React from 'react'
import { PropTypes } from 'prop-types'
import { Range, getTrackBackground } from 'react-range'
import { PILLAR_COLOURS, RESOURCEdb } from '@wellbeingxltd/fe-lib/constants'
import './styles.scss'

const { SLEEP, EXERCISE, NUTRITION, OCCUPATION, STRESS, COMMUNITY } = RESOURCEdb.PILLARS

const STEP = 1
const MIN = 0
const MAX = 10

const COLORS_M = {
    Sleep: PILLAR_COLOURS[SLEEP].medium,
    Exercise: PILLAR_COLOURS[EXERCISE].medium,
    Nutrition: PILLAR_COLOURS[NUTRITION].medium,
    MeaningfulActivity: PILLAR_COLOURS[OCCUPATION].medium,
    StressManagement: PILLAR_COLOURS[STRESS].medium,
    Community: PILLAR_COLOURS[COMMUNITY].medium,
    LifeSatisfaction: PILLAR_COLOURS.blue.medium,
    PositiveEmployer: PILLAR_COLOURS.blue.medium,
    default: PILLAR_COLOURS.blue.dark,
}
const COLORS_L = {
    Sleep: PILLAR_COLOURS[SLEEP].light,
    Exercise: PILLAR_COLOURS[EXERCISE].light,
    Nutrition: PILLAR_COLOURS[NUTRITION].light,
    MeaningfulActivity: PILLAR_COLOURS[OCCUPATION].light,
    StressManagement: PILLAR_COLOURS[STRESS].light,
    Community: PILLAR_COLOURS[COMMUNITY].light,
    LifeSatisfaction: PILLAR_COLOURS.blue.light,
    PositiveEmployer: PILLAR_COLOURS.blue.light,
    default: PILLAR_COLOURS.grey.light,
}
export const RangeSlider = ({ values = [0], assessmentList, index, onChange = () => {}, colour = 'default', ariaLabelledby, onboarding }) => {
    return (
        <div>
            {onboarding && (
                <p style={{ paddingBottom: 12, fontSize: 12 }}>
                    {values[0] !== null ? assessmentList[index]?.answersLabel[values[0]]?.text : 'Drag slider'}
                </p>
            )}
            <Range
                step={STEP}
                min={MIN}
                max={MAX}
                values={values}
                onChange={values => onChange(ariaLabelledby, values)}
                renderTrack={({ props, children }) => (
                    <div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} style={{ ...props.style }}>
                        <div
                            className="RangeSlider__track"
                            ref={props.ref}
                            style={{
                                background: getTrackBackground({
                                    values: values,
                                    colors: [COLORS_M[colour], COLORS_L[colour]],
                                    min: MIN,
                                    max: MAX,
                                }),
                                alignSelf: 'center',
                            }}
                        >
                            {children}
                        </div>
                    </div>
                )}
                renderThumb={({ props }) =>
                    values?.[0] ? (
                        <div className={`RangeSlider__thumb RangeSlider__thumb--${colour}`} aria-labelledby={ariaLabelledby} {...props}>
                            {values[0]}
                        </div>
                    ) : (
                        <div className={`RangeSlider__thumb RangeSlider__thumb--${colour}-L`} aria-labelledby={ariaLabelledby} {...props}>
                            -
                        </div>
                    )
                }
            />
        </div>
    )
}

RangeSlider.propTypes = {
    values: PropTypes.arrayOf(PropTypes.number).isRequired,
    onChange: PropTypes.func.isRequired,
    colour: PropTypes.string.isRequired,
}
